export enum SlideGroup {
  Upcoming = "current",
  Past = "history",
}

export enum SlideType {
  Compute = "compute",
  DataTransfer = "data_transfer",
  DataExport = "data_export",
  SystemUpdate = "system_update",
}

export interface RunningProcessSlide {
  group: SlideGroup;
  type: SlideType;
  date: string;
  title: string;
  titleLocales: {
    en: string;
    sv: string;
  };
  period: string;
  notifyText?: string;
  notifyTextLocales: {
    en: string;
    sv: string;
  };
  // Add other fields as needed
}

// Section title/note mapping type
export type SectionTextMap = {
  [key in SlideGroup]: {
    sectionTitle: string;
    sectionNote?: string;
  }
};

// Slide type config for icon/color
export interface SlideTypeConfig {
  cardBg: string;
  icon: string;
}

export type SlideTypeConfigMap = {
  [key in SlideGroup]: {
    [type in SlideType]?: SlideTypeConfig;
  }
};

export type ApiProcessEvent = {
  _id: string;
  cutOffDate: string;
  code: string;
  name: string;
  name_sv: string;
  infoText: string;
  description: string;
  description_sv: string;
  period: string;
  time: string;
  group: 'history' | 'current';
  color?: string;
}

// Dashboard Types
export interface DashboardPie {
  totalEmployee: number;
  dataset: any[];
}

export interface DashboardLineChartDataset {
  companyId: number;
  value: number;
  label: string;
  labelKey: string;
}

export interface DashboardLineChart {
  date: string;
  dataset: DashboardLineChartDataset[];
}

export interface DashboardErrors {
  cost_validation_count: number;
  employee_policy_count: number;
}

export interface CompanyAdminDashboardData {
  totalEmployee: number;
  totalSalary: number;
  socialFees: number;
  specialSalaryTax: number;
  totalPension: number;
  pie: DashboardPie;
  lineChart: DashboardLineChart[];
  errors: DashboardErrors;
}

export interface CompanyOverviewChartSectionType {
  lineChart: DashboardLineChart[];
  pieChart: DashboardPie;
}
